import getFulfilmentIds from "../../../../../../getFulfilmentIds";
import getFulfilmentType, {
  FULFILMENT_TYPE
} from "../../../../../../getFulfilmentType";

const getNonCorePrimaryItemsCount = savedItemProducts =>
  savedItemProducts.filter(({ source, seller }) => {
    const { sourceId, sellerId } = getFulfilmentIds({ source, seller });

    return (
      getFulfilmentType({ sourceId, sellerId }) !== FULFILMENT_TYPE.CORE_PRIMARY
    );
  }).length;

export default getNonCorePrimaryItemsCount;
